var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-encours-tiers',{attrs:{"tiersId":_vm.collectivite.id,"soldeTiersInfo":_vm.soldeTiersInfo,"tiersInformation":_vm.collectivite,"soldeAtInfiniteDay":_vm.soldeAtInfiniteDay,"isFromDetailClient":false}})}
var staticRenderFns = []

export { render, staticRenderFns }